import { emailSchema, phoneRequiredSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const addFundingSourceSchema = object().shape({
    name: stringRequiredSchema,
    // contact_first_name: stringRequiredSchema,
    // contact_last_name: stringRequiredSchema,
    // contact_title: stringRequiredSchema,
    // email: emailSchema,
    // phone_number: phoneRequiredSchema,
    description: stringOptionalSchema,
    status: stringRequiredSchema
});

export default addFundingSourceSchema;